import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useMemo } from '@wordpress/element';
import { TabPanel } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
const blocksTab = {
  name: 'blocks',

  /* translators: Blocks tab title in the block inserter. */
  title: __('Blocks')
};
const patternsTab = {
  name: 'patterns',

  /* translators: Patterns tab title in the block inserter. */
  title: __('Patterns')
};
const reusableBlocksTab = {
  name: 'reusable',

  /* translators: Reusable blocks tab title in the block inserter. */
  title: __('Reusable')
};

function InserterTabs(_ref) {
  let {
    children,
    showPatterns = false,
    showReusableBlocks = false,
    onSelect
  } = _ref;
  const tabs = useMemo(() => {
    const tempTabs = [blocksTab];

    if (showPatterns) {
      tempTabs.push(patternsTab);
    }

    if (showReusableBlocks) {
      tempTabs.push(reusableBlocksTab);
    }

    return tempTabs;
  }, [blocksTab, showPatterns, patternsTab, showReusableBlocks, reusableBlocksTab]);
  return createElement(TabPanel, {
    className: "block-editor-inserter__tabs",
    tabs: tabs,
    onSelect: onSelect
  }, children);
}

export default InserterTabs;
//# sourceMappingURL=tabs.js.map